import { TicketBatch } from "../../components/modal-tickets/types/ticket-batch.type";

/** Copies the API snapshot without changing its ordering or batch metadata. */
export function normalizeBatches(batches: TicketBatch[]): TicketBatch[] {
  return batches.map((batch) => ({
    ...batch,
    tickets: batch.tickets.map((ticket) => ({
      ...ticket,
      price: Number(ticket.price),
    })),
  }));
}
